
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { StandardOption, OptionSelectableMixin } from ".";

@Component({
})
export default class MultiOptionSelectableMixin extends Mixins(OptionSelectableMixin) {
  editingSource: any[];

  get selectedOptions(): StandardOption<any>[] {
    return Enumerable.from(!this.editingSource ? [] : this.editingSource)
      .select(s => this.findOption(s, this.options))
      .where(o => !!o)
      .toArray();
  }

  set selectedOptions(options: StandardOption<any>[]) {
    this.editingSource = Enumerable.from(options)
      .select(o => o.value)
      .toArray();
  }
}
